import { cn } from '@/libs/utils';

export default function PropagationWrapper({ children, className }) {
  return (
    <div
      className={cn('w-max', className)}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}
